var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"ma-auto":""}},[_c('div',{staticClass:"custom-loader"},[_vm._v("i")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }